
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class ItemDiscountGrid extends Serenity.EntityGrid<ItemDiscountRow, any> {
        protected getColumnsKey() { return 'Administration.ItemDiscount'; }
        protected getDialogType() { return ItemDiscountDialog; }
        protected getIdProperty() { return ItemDiscountRow.idProperty; }
        protected getInsertPermission() { return ItemDiscountRow.insertPermission; }
        protected getLocalTextPrefix() { return ItemDiscountRow.localTextPrefix; }
        protected getService() { return ItemDiscountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}